if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


function replaceSpecialChars(container) {
  console.log(document.querySelector(container));

  let edition_texts = document.querySelector(container).innerHTML;
  console.log(document.querySelector(container).innerHTML);
  if (edition_texts) {
    let result = edition_texts.replaceAll("|", "<br>");
    result = result.replaceAll("*_", "&nbsp;");
    result = result.replaceAll("**", "<b>");
    result = result.replaceAll("*", "</b>");
    document.querySelector(container).innerHTML = result;
    console.log(result);
  }
}

replaceSpecialChars('#editions');
replaceSpecialChars('#og-editions');

let editions = document.querySelector('#og-editions');
let productBox = document.querySelector('.product');
if (editions) {
	productBox.insertAdjacentElement('afterend', editions);
}
function toggle_visibility(buttonEl) {
  	let e = buttonEl.nextSibling;
    if (buttonEl.getAttribute('id') == 'btn-table-of-content') {
      e = buttonEl.nextSibling.nextSibling;
    }
	e.style.display = ((e.style.display!='none') ? 'none' : 'block');
}



let edition_text = document.querySelector('#editions').innerHTML;
let replaced = edition_text.replaceAll("%weiter%", '<a onclick="toggle_visibility(this)" class="more-btn">Weiter <span>→</span></a><div class="more-text" style="display: none;">');
document.querySelector('#editions').innerHTML = replaced;


